import React from 'react';
import { Grid, InputAdornment } from '@material-ui/core';
// eslint-disable-next-line import/no-extraneous-dependencies
import { END_DATE, START_DATE } from '@datepicker-react/hooks';
import Calendar from '@rcg/ui-react/lib/assets/svg/calendar';
import VerticalDivider from '@rcg/ui-react/lib/components/Icons/VerticalDivider';
import { TextField, useGlobal } from '@rcg/ui-react';
import useStyles from './index.style';

const InputRangeDate = (props) => {
  const {
    datepickerIcon = <Calendar />,
    dividerInputIcon = <VerticalDivider />,
    placeholderStartDate = '',
    placeholderEndDate = '',
    handleDatepicker = () => {},
    labelDatepicker = '',
    startDate = new Date(),
    endDate = new Date(),
    focusedInput = '',
    oneWay = false,
  } = props;

  const classes = useStyles();
  const {
    data: { localizedDayjs },
  } = useGlobal();

  let inputContainerClass = classes.datepickerInputContainer;
  if (focusedInput === START_DATE) {
    inputContainerClass = classes.datepickerInputContainerStart;
  }
  if (focusedInput === END_DATE) {
    inputContainerClass = classes.datepickerInputContainerEnd;
  }
  return (
    <Grid
      container
      alignItems="flex-end"
      data-testid="gridWrapperRangeDate"
      className={`${inputContainerClass} ${oneWay ? classes.datePickerOneWay : ''}`}
      onClick={handleDatepicker}>
      <Grid item xs={oneWay ? 12 : 6}>
        <TextField
          name="startDate"
          data-testid="startDate"
          label={labelDatepicker}
          className={classes.datepickerInput}
          value={startDate && localizedDayjs(startDate).format('ddd, MMM DD')}
          placeholder={placeholderStartDate}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={classes.inputAdornment}>
                {datepickerIcon}
              </InputAdornment>
            ),
            readOnly: true,
          }}
        />
      </Grid>
      {!oneWay && (
        <Grid item xs={6}>
          <TextField
            name="endDate"
            className={classes.datepickerInput}
            placeholder={placeholderEndDate}
            value={endDate && localizedDayjs(endDate).format('ddd, MMM DD')}
            InputProps={{
              startAdornment: focusedInput ? (
                <></>
              ) : (
                <InputAdornment position="start" className={classes.inputAdornmentEnd}>
                  {dividerInputIcon}
                </InputAdornment>
              ),
              readOnly: true,
            }}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default InputRangeDate;
